<template>
  <el-dialog title="选择/新增 成员" :visible.sync="value" width="80%" :close-on-click-modal="false" :before-close="handleClose" @open="handleOpen">
    <div style="height:450px;overflow:auto">
      <el-tabs v-model="activeName">
        <el-tab-pane label="团队选择" name="selTeam">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-table
                :data="endUserIdentityList"
                border
                style="width: 100%"
                @row-click="handleTeamRowClick"
              >
                <el-table-column
                  prop="danWeiMingCheng"
                  label="单位名称"
                  width="150"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span :class="scope.row.danWeiBuMenKey===currentIdentityId?'row1':''">{{ scope.row.danWeiMingCheng }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="danWeiBuMenFullName"
                  label="部门/科研团队"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span :class="scope.row.danWeiBuMenKey===currentIdentityId?'row1':''">{{ scope.row.danWeiBuMenFullName }}</span>
                  </template>
                </el-table-column>

              </el-table>
            </el-col>
            <el-col :span="18">
              <el-table ref="tabTeamMember" :data="memberList">
                <el-table-column type="selection" />
                <el-table-column label="姓名" prop="userName" />
                <el-table-column label="角色" prop="memberRoleDictKeyItemName" />
              </el-table>
            </el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane label="好友选择" name="selFriend">
          <el-input v-model="searchVal" clearable style="padding:5px;width:50%" prefix-icon="el-icon-search" size="mini" placeholder="姓名/手机号/标签/单位名称/研究领域/研究方向" />
          <el-table
            ref="tabFriend"
            class="table-list"
            :border="true"
            :data="allFriends.filter(data => !searchVal || (data.userName&&data.userName.indexOf(searchVal)>=0) || (data.phoneNumber&&data.phoneNumber.indexOf(searchVal)>=0) || (data.userName2&&data.userName2.indexOf(searchVal)>=0) || (data.danWeiMingCheng&&data.danWeiMingCheng.indexOf(searchVal)>=0) || (data.danWeiMingCheng&&data.danWeiMingCheng.indexOf(searchVal)>=0) || (data.yanJiuFangXiang&&data.yanJiuFangXiang.indexOf(searchVal)>=0) || (data.yanJiuLingYu&&data.yanJiuLingYu.indexOf(searchVal)>=0) )"
            style="width: 100%;"
            height="342"
          >
            <el-table-column type="selection" />
            <!-- 姓名 -->
            <el-table-column
              prop="userName"
              label="姓名"
              width="120"
              sortable
            />

            <!-- 手机号码 -->
            <el-table-column
              prop="phoneNumber"
              label="手机号码"
              width="120"
              sortable
            />

            <!-- 电子邮箱 -->
            <el-table-column
              prop="emailAddress"
              label="电子邮箱"
              width="120"
              sortable
            />

            <!-- 标签 -->
            <el-table-column
              prop="userName2"
              label="标签"
              width="300"
              sortable
            >
              <template slot-scope="scope">
                <el-tag
                  v-for="(tag,index) in getTags(scope.row.userName2)"
                  :key="index"
                >
                  {{ tag }}
                </el-tag>
              </template>
            </el-table-column>

            <!-- 性别 -->
            <el-table-column
              prop="sexDictKeyItemName"
              label="性别"
              width="80"
              sortable
              align="center"
            />

            <!-- 单位名称 -->
            <el-table-column
              prop="danWeiMingCheng"
              label="单位名称"
              width="150"
              sortable
              :show-overflow-tooltip="true"
            />

            <!-- 部门 -->
            <el-table-column
              prop="buMen"
              label="部门"
              width="120"
              sortable
              :show-overflow-tooltip="true"
            />

            <!-- 科室 -->
            <el-table-column
              prop="keShi"
              label="科室"
              width="120"
              sortable
              :show-overflow-tooltip="true"
            />

            <!-- 职务 -->
            <el-table-column
              prop="zhiWu"
              label="职务"
              width="120"
              sortable
            />

            <!-- 学位 -->
            <el-table-column
              prop="xueWeiDictIdItemName"
              label="学位"
              width="120"
              sortable
            />

            <!-- 研究领域 -->
            <el-table-column
              prop="yanJiuLingYu"
              label="研究领域"
              width="150"
              sortable
            />

            <!-- 研究方向 -->
            <el-table-column
              prop="yanJiuFangXiang"
              label="研究方向"
              width="150"
              sortable
            />
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="新增" name="add">
          <el-form ref="postForm" :model="postForm" :rules="rules" label-width="100px" class="demo-ruleForm" label-position="right">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="姓名" prop="userName">
                  <el-input v-model="postForm.userName" placeholder="姓名" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号" prop="phoneNumber">
                  <el-input v-model="postForm.phoneNumber" placeholder="手机号" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮箱" prop="emailAddress">
                  <el-input v-model="postForm.emailAddress" placeholder="邮箱" />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="性别" prop="sexDictKey">
                  <Combox v-model="postForm.sexDictKey" type-id="D04" :option-data="getComboxData('D04')" :add-client="false" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="学位" prop="xueWeiDictId">
                  <Combox v-model="postForm.xueWeiDictId" type-id="D07" :option-data="getComboxData('D07')" :add-client="false" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="单位名称" prop="danWeiMingCheng">
                  <el-input v-model="postForm.danWeiMingCheng" placeholder="单位名称" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="部门" prop="buMen">
                  <el-input v-model="postForm.buMen" placeholder="部门" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="科室" prop="keShi">
                  <el-input v-model="postForm.keShi" placeholder="科室" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职务" prop="zhiWu">
                  <el-input v-model="postForm.zhiWu" placeholder="职务" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="研究领域" prop="yanJiuLingYu">
                  <el-input v-model="postForm.yanJiuLingYu" placeholder="研究领域" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="研究方向" prop="yanJiuFangXiang">
                  <el-input v-model="postForm.yanJiuFangXiang" placeholder="研究方向" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="">
                  <el-checkbox v-model="postForm.saveAsNewContact">保存到通讯录</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
      </el-tabs>

    </div>
    <div class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button v-if="activeName==='add'" type="primary" @click="handleSave()">保 存</el-button>
      <el-button v-if="activeName==='selFriend'" type="primary" @click="handleSelFriend()">选 择</el-button>
      <el-button v-if="activeName==='selTeam'" type="primary" @click="handleSelTeam()">选 择</el-button>
    </div>
  </el-dialog>
</template>

<script>
import pathReq from '@/api/pathlist'
import Combox from '@/views/managesystem/gz/com/Combox'
export default {
  components: { Combox },
  props: {
    value: { type: Boolean, default: false },
    moduleCode: { type: String, default: '' },
    moduleKey: { type: Number, default: null }
  },
  data() {
    return {
      activeName: 'selTeam',
      postForm: {},
      allComboxData: [],
      allFriends: [],
      searchVal: '',
      searchVal2: '',
      rules: {
        userName: [
          { required: true, message: '请输入姓名', trigger: 'change,blur' }
        ],
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'change,blur' }
        ]
      },
      endUserIdentityList: [], // 团队数据
      currentSelectedRow: {}, // 当前选中团队
      memberList: [], // 团队成员
      currentIdentityId: null // 当前所属身份ID

    }
  },
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D04;D07').then(res => {
      this.allComboxData = res.data.result
    })
    pathReq.getNoParams('/api/services/app/EndUserUnitMember/GetCurrentUnitData')
      .then(resp => {
        this.currentIdentityId = resp.data.result.currentIdentityId
      })
  },
  methods: { // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    /** 关闭 */
    handleClose() {
      this.$refs['postForm'].resetFields()
      this.activeName = 'selTeam'
      this.$emit('input', false)
    },
    /** 打开 */
    handleOpen() {
      const that = this
      var path = '/api/services/app/WorkEventMemberNewService/GetEditEventMemberNew'
      pathReq
        .getNoParams(path)
        .then(res => {
          that.postForm = res.data.result
          that.postForm.moduleCode = that.moduleCode
          that.postForm.moduleKey = that.moduleKey
        })
      /** 取得所有好友数据*/
      var path2 = '/api/services/app/Contact/GetPagedListContactsAll'
      pathReq
        .getNoParams(path2)
        .then(res => {
          that.allFriends = res.data.result
        })
      /** 取得所有团队名称 */
      pathReq.getNoParams('/api/services/app/EndUserInfo/GetUserIdentity')
        .then(resp => {
          that.endUserIdentityList = resp.data.result
        })
    },

    /** 保存 */
    handleSave() {
      const that = this
      var path = '/api/services/app/WorkEventMemberNewService/EventMemberNewAdd'
      this.$refs['postForm'].validate(valid => {
        if (valid) {
          const data = that.postForm
          pathReq.dataUpdate(path, data).then(res => {
            if (res.data.result) {
              that.$notify({
                message: res.data.result,
                type: 'success',
                duration: 2000
              })
            }
            this.$emit('input', false)
            this.activeName = 'selTeam'
            this.$emit('save-success')
          })
        }
      })
    },
    /** 好友选择 */
    handleSelFriend() {
      const that = this
      if (this.$refs.tabFriend.selection.length === 0) {
        this.$message.error('请选择好友')
        return
      }
      const addTarget = this.$refs.tabFriend.selection.map(item => {
        return { id: item.id, isFromFriendList: item.isFromFriendList }
      })

      const path = '/api/services/app/WorkEventMemberNewService/AddByFriends'
      const data = {
        moduleCode: this.moduleCode,
        moduleKey: this.moduleKey,
        contactList: addTarget
      }

      pathReq.dataUpdate(path, data).then(res => {
        if (res.data.result) {
          that.$notify({
            message: '添加成功',
            type: 'success',
            duration: 2000
          })
        }
        this.allFriends = []
        this.$emit('input', false)
        this.activeName = 'selTeam'
        this.$emit('save-success')
      })
    },
    /** 好友选择 */
    handleSelTeam() {
      const that = this
      if (this.$refs.tabTeamMember.selection.length === 0) {
        this.$message.error('请选择团队成员')
        return
      }

      const addTarget = this.$refs.tabTeamMember.selection.map(item => {
        return item.id
      })

      const path = '/api/services/app/WorkEventMemberNewService/AddByTeamMembers'
      const data = {
        moduleCode: this.moduleCode,
        moduleKey: this.moduleKey,
        teamMemberKeys: addTarget
      }

      pathReq.dataUpdate(path, data).then(res => {
        if (res.data.result) {
          that.$notify({
            message: '添加成功',
            type: 'success',
            duration: 2000
          })
        }
        this.memberList = []
        this.$emit('input', false)
        this.activeName = 'selTeam'
        this.$emit('save-success')
      })
    },
    /** 取得标签 */
    getTags(str) {
      if (!str) {
        return []
      } else {
        return str.split(',')
      }
    },

    /** 团队名称行点击 */
    handleTeamRowClick(row, column) {
      this.currentSelectedRow = row
      this.handleTeamMemberLoadData()
    },
    /** 刷新团队成员数据 */
    handleTeamMemberLoadData() {
      const that = this
      const path = '/api/services/app/EndUserUnitMember/GetEndUserUnitMembersByBuMenKey'
      pathReq.getList(path, { danWeiBuMenKey: this.currentSelectedRow.danWeiBuMenKey }).then((res) => {
        if (res.data.success) {
          that.memberList = res.data.result
        }
      })
    }
  }

}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  margin-top: 10px;
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 100% !important;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>
